import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import usePersonnelFilesApi from './config';
import { parseTableParams } from '../../utils/Utils';
import DataTable from '../../components/ui/DataTable';

const Container = styled.div``;

// Salt-okunur liste ekranı: "Yeni" butonu yok, aksiyon EmployeesPage'deki gibi satır
// tıklamasıyla /personnel-files/:employeeId detayına gider (hem aktif hem çıkmış personel —
// çıkmış satırlar yalnızca includeInactive filtresi açıkken görünür, bkz. config/index.js).
export default function PersonnelFilesPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const [queryParams, setQueryParams] = useState({ pageSize: 25, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);

  const { fetching, data, pagination, columns } = usePersonnelFilesApi(queryParams);

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    setQueryParams(parseTableParams(tableState, columns));
  }, [columns]);

  const handleFilterConfirm = useCallback((newFilterList) => {
    setFilterList(newFilterList);
  }, []);

  const handleRowClick = useCallback((row) => {
    history.push(`/personnel-files/${row.employeeId}`);
  }, [history]);

  return (
    <Container>
      <DataTable
        title={t('personnelFile.list.title')}
        fetching={fetching}
        columns={columns}
        data={data}
        totalRowCount={pagination.totalRowCount}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        canCreateNewRecord={false}
        filterList={filterList}
        onFilterConfirm={handleFilterConfirm}
        onTableChanged={handleDataStateChange}
        onRowClick={handleRowClick}
      />
    </Container>
  );
}
